import React from "react";

export function CupoProgressBar({ detalle, compact = false }) {
    const usadas = Number(detalle.sesiones_usadas) || 0;
    const total = Number(detalle.sesiones_total) || 0;
    const pendientes = Number(detalle.sesiones_pendientes) || 0;
    const pct = total > 0 ? Math.min(100, Math.round((usadas / total) * 100)) : 0;
    const completado = total > 0 && usadas >= total;

    const statsText = compact && pendientes > 0 && !completado
        ? `${usadas} de ${total} usadas (${pendientes} pendiente${pendientes === 1 ? "" : "s"})`
        : `${usadas} de ${total} usadas`;

    return (
        <div className="plan-cupo-row">
            <div className="plan-cupo-row__head">
                <span className="plan-cupo-row__nombre">{detalle.servicio_nombre}</span>
                <span className="plan-cupo-row__stats">
                    {statsText}
                </span>
                {!compact && (
                    <span className={`plan-cupo-badge ${completado ? "plan-cupo-badge--ok" : "plan-cupo-badge--pending"}`}>
                        {completado ? "Completado" : `${pendientes} pendiente${pendientes === 1 ? "" : "s"}`}
                    </span>
                )}
            </div>
            <div className="plan-cupo-progress-track" aria-hidden="true">
                <div
                    className={`plan-cupo-progress-fill ${completado ? "plan-cupo-progress-fill--ok" : ""}`}
                    style={{ width: `${pct}%` }}
                />
            </div>
        </div>
    );
}

export function CupoProgressList({ detalleList, emptyText = "Sin detalle de servicios.", compact = false }) {
    if (!detalleList?.length) {
        return <span className="text-muted small">{emptyText}</span>;
    }
    return (
        <div className="plan-cupo-resumen">
            {detalleList.map((d) => (
                <CupoProgressBar key={d.id} detalle={d} compact={compact} />
            ))}
        </div>
    );
}

export function CupoProgressStyles() {
    return (
        <style>{`
            .plan-cupo-section-label {
                font-size: 0.72rem;
                text-transform: uppercase;
                letter-spacing: 0.04em;
                color: #6b7280;
            }
            .plan-cupo-resumen {
                background: #f8fafc;
                border: 1px solid #e5e7eb;
                border-radius: 10px;
                padding: 14px 16px;
            }
            .plan-cupo-row + .plan-cupo-row { margin-top: 14px; }
            .plan-cupo-row__head {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 8px;
                margin-bottom: 6px;
            }
            .plan-cupo-row__nombre {
                font-weight: 700;
                color: #1f2937;
                flex: 1 1 160px;
            }
            .plan-cupo-row__stats {
                font-size: 0.78rem;
                color: #6b7280;
            }
            .plan-cupo-badge {
                font-size: 0.68rem;
                font-weight: 700;
                border-radius: 999px;
                padding: 2px 8px;
            }
            .plan-cupo-badge--ok {
                color: #047857;
                background: #ecfdf5;
                border: 1px solid #a7f3d0;
            }
            .plan-cupo-badge--pending {
                color: #b45309;
                background: #fffbeb;
                border: 1px solid #fde68a;
            }
            .plan-cupo-progress-track {
                height: 8px;
                background: #e5e7eb;
                border-radius: 999px;
                overflow: hidden;
            }
            .plan-cupo-progress-fill {
                height: 100%;
                background: #323a45;
                border-radius: 999px;
                transition: width 0.2s ease;
            }
            .plan-cupo-progress-fill--ok {
                background: #323a45;
            }
        `}</style>
    );
}

export default CupoProgressBar;
